













































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import {
  getCollectionEventById,
  CollectionEventDetailsModel,
  getCollectionEventImage,
  GetCollectionEventImageResponse,
  generateLetter,
  sendEmail,
  downloadPdf
} from "@/api/CollectionEvents";
import mapStore from "@/store/mapStore";
import CollectionEventDetailsHeader from "@/components/CollectionEvents/CollectionEventDetailsHeader.vue";
import CollectionEventDetailsList from "@/components/CollectionEvents/CollectionEventDetailsList.vue";
import CollectionIssueHistory from "@/components/CollectionEvents/CollectionIssueHistory.vue";
import CollectionLetterHistory from "@/components/CollectionEvents/CollectionLetterHistory.vue";
import CollectionNotes from "@/components/CollectionEvents/CollectionNotes.vue";
import ExpandableImage from "@/components/ExpandableImage/ExpandableImage.vue";
import { LoadingStore } from "@/store/loadingStore";
import GenerateLettersForm from "@/components/Letters/GenerateLettersForm.vue";
import { LetterTemplateModel } from "@/api/LetterTemplates";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { Map as LMap } from "leaflet";
import userStore from "@/store/userStore";
import notificationStore from "@/store/notificationStore";
import { MapProvider } from "@/api/CouncilConfiguration";

const L = window["L"];
const validationObserver = Observer(ValidationObserver);
@Observer
@Component({
  components: {
    CollectionEventDetailsHeader,
    CollectionEventDetailsList,
    CollectionIssueHistory,
    CollectionLetterHistory,
    CollectionNotes,
    GenerateLettersForm,
    ValidationProvider,
    ValidationObserver: validationObserver,
    ExpandableImage
  }
})
export default class CollectionEventDetails extends Vue {
  @Prop(Number) readonly collectionEventId: number | undefined;
  @Prop(Boolean) readonly isCollectionIssue: boolean | undefined;
  @Prop(Number) readonly collectionEventType: number | undefined;
  loading = new LoadingStore();
  details: CollectionEventDetailsModel | null = null;
  image: GetCollectionEventImageResponse | null = null;
  mapStore = mapStore;
  isGenerateLetterMenuOpen = false;
  selectedLetterTemplate: LetterTemplateModel | null = null;
  isSendEmailMenuOpen = false;
  email = "";
  emailSentSnackbar = false;
  userStore = userStore;

  async mounted() {
    this.fetchData();
  }

  @Watch("collectionEventId")
  fetchData() {
    this.loading.track(async () => {
      try {
        if (this.collectionEventId && this.isCollectionIssue !== undefined && this.collectionEventType !== undefined) {
          this.image = null;
          const getCollectionEventPromise = getCollectionEventById({
            collectionEventId: this.collectionEventId,
            isCollectionIssue: this.isCollectionIssue,
            collectionEventType: this.collectionEventType
          });
          if (this.isCollectionIssue) {
            const getCollectionEventImagePromise = getCollectionEventImage({ collectionEventId: this.collectionEventId, collectionEventType: this.collectionEventType });
            this.image = await getCollectionEventImagePromise;
          }
          this.details = await getCollectionEventPromise;

          setTimeout(() => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const streetLayer =
              userStore.councilConfiguration?.mapProvider == MapProvider.Old
                ? (L as any).bingLayer(process.env.VUE_APP_MAP_TILES_API_KEY, { imagerySet: "RoadOnDemand" })
                : L.tileLayer(`${process.env.VUE_APP_HERE_MAP_BASE_URL}?apiKey=${process.env.VUE_APP_HERE_MAP_TILES_API_KEY}`, {
                    maxZoom: mapStore.maxZoom,
                    minZoom: mapStore.minZoom,
                    attribution: "&copy;2024 HERE Technologies"
                  });

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ((this.$refs.collectionEventMap as any).mapObject as LMap).addLayer(streetLayer);
          }, 10);
        } else this.details = null;
      } catch (error) {
        notificationStore.error("An unexpected error occurred while loading the issue details");
        this.$emit("load-details-error");
      }
    }, "load");
  }

  async generateLetter() {
    await this.loading.track(async () => {
      try {
        if (!this.selectedLetterTemplate) return;
        if (!this.collectionEventId) return;
        await generateLetter({ collectionIssueId: this.collectionEventId, letterTemplateId: this.selectedLetterTemplate?.id });
        this.isGenerateLetterMenuOpen = false;
      } catch (error) {
        notificationStore.error("An unexpected error occurred while generating the letter");
      }
    }, "generateLetter");
  }

  async downloadPdf() {
    await this.loading.track(async () => {
      try {
        if (!this.collectionEventId) return;
        await downloadPdf({ collectionIssueId: this.collectionEventId });
      } catch (error) {
        notificationStore.error("An unexpected error occurred while downloading the PDF");
      }
    }, "downloadPdf");
  }

  async sendEmail(resetForm: () => void) {
    await this.loading.track(async () => {
      try {
        if (!this.collectionEventId) return;
        await sendEmail({ collectionIssueId: this.collectionEventId, email: this.email });
        this.isSendEmailMenuOpen = false;
        this.emailSentSnackbar = true;
        this.email = "";
        resetForm();
      } catch (error) {
        notificationStore.error("An unexpected error occurred while sending the email");
      }
    }, "sendEmail");
  }

  onSendEmailMenuToggle() {
    if (!this.isSendEmailMenuOpen) {
      this.email = "";
    }
  }
}
